export class CrdtAlgorithmOptionalValue {
    algoType = 'OptionalValue';
}
export function isOptionalValueCrdtAlgorithm(algo) {
    return algo.algoType === 'OptionalValue';
}
//# sourceMappingURL=CrdtAlgorithmOptionalValue.js.map